<!--
 * @Description: 法人
 * @Date: 2025-05-20 18:01:16
-->

<template>
  <div class="account-info__items account-info__multiple">
    <BaseTextTitle class="account-info__items__title">法人信息</BaseTextTitle>
    <BaseTextContent class="account-info__content">
      <BaseFormItem
        label="姓名"
        prop="legalPersonName"
        :rules="[
          {
            required: true,
            trigger: 'change',
            message: '请输入'
          }
        ]"
      >
        <BaseInput
          style="width: 100%"
          type="text"
          placeholder="请输入"
          v-model="formData.legalPersonName"
        ></BaseInput>
      </BaseFormItem>
      <BaseFormItem
        label="身份证号"
        prop="legalPersonCardCode"
        :rules="[
          {
            required: true,
            trigger: 'change',
            message: '请输入'
          }
        ]"
      >
        <BaseInput
          style="width: 100%"
          type="text"
          placeholder="请输入"
          inputTextReplace
          :inputTexts="['英文字母', '数字']"
          v-model="formData.legalPersonCardCode"
        ></BaseInput>
      </BaseFormItem>
      <BaseFormItem
        label="手机号"
        prop="legalPhone"
        :rules="[
          {
            required: true,
            trigger: 'change',
            message: '请输入'
          }
        ]"
      >
        <BaseInput
          style="width: 100%"
          type="tel"
          placeholder="请输入"
          clearable
          :maxlength="11"
          v-model="formData.legalPhone"
        ></BaseInput>
      </BaseFormItem>
      <BizFormTimes
        class="account-info__block"
        label="证件有效期"
        startProp="legalPersonCardStartAt"
        endProp="legalPersonCardEndAt"
        v-model:start="formData.legalPersonCardStartAt"
        v-model:end="formData.legalPersonCardEndAt"
      />

      <BaseFormItem
        style="grid-column-start: 1; grid-column-end: 3"
        label="身份证照片（人像面）"
        prop="legalPersonCardZheng"
        :rules="[
          {
            required: true,
            trigger: 'change',
            message: '请上传'
          }
        ]"
      >
        <BaseUpload
          style="width: 100%"
          ref="legalPersonCardZhengRef"
          listType="picture-card"
          :disabled="disabled"
          :accept="['.jpg', '.jpeg', '.png', '.JPG', '.JPEG', '.PNG']"
          :drag="false"
          :limit="1"
          :limitSize="5"
          :multiple="false"
          :auto-upload="true"
          :onError="onUploadErr"
          :http-request="uploadApi"
          :beforeRemove="
            (file, remove) => {
              remove();
              onUploadRemove('legalPersonCardZheng');
              return true;
            }
          "
          v-model:fileList="uploadModelMap.legalPersonCardZheng"
          @change="v => onUploadChange(v, 'legalPersonCardZheng')"
        >
          <template #tip>
            <span class="enterprise-real-form-upload">
              请上传证件的彩色扫描件或照片，并确保您上传的图片信息内容清晰、可辨，单个文件大小不超过
              5M；
            </span>
          </template>
        </BaseUpload>
      </BaseFormItem>
      <BaseFormItem
        style="grid-column-start: 3; grid-column-end: 5"
        label="身份证照片（国徽面）"
        prop="legalPersonCardFan"
        :rules="[
          {
            required: true,
            trigger: 'change',
            message: '请上传'
          }
        ]"
      >
        <BaseUpload
          style="width: 100%"
          ref="legalPersonCardFanRef"
          listType="picture-card"
          :disabled="disabled"
          :accept="['.jpg', '.jpeg', '.png', '.JPG', '.JPEG', '.PNG']"
          :drag="false"
          :limit="1"
          :limitSize="5"
          :multiple="false"
          :auto-upload="true"
          :onError="onUploadErr"
          :http-request="uploadApi"
          :beforeRemove="
            (file, remove) => {
              remove();
              onUploadRemove('legalPersonCardFan');
              return true;
            }
          "
          v-model:fileList="uploadModelMap.legalPersonCardFan"
          @change="v => onUploadChange(v, 'legalPersonCardFan')"
        >
          <template #tip>
            <span class="enterprise-real-form-upload">
              请上传证件的彩色扫描件或照片，并确保您上传的图片信息内容清晰、可辨，单个文件大小不超过5M
            </span>
          </template>
        </BaseUpload>
      </BaseFormItem>
    </BaseTextContent>
  </div>
</template>

<script lang="ts" setup>
import {
  BaseFormItem,
  BaseInput,
  BaseUpload,
  BaseTextContent,
  BaseTextTitle
} from 'xrk-components';
import { storeToRefs } from 'pinia';
import infoStore from '../../store/info';
import { uploadApi } from '@/common/data-source/common/apis';
import { useUpload } from '../../hooks';
import BizFormTimes from '@/components/biz/biz-form-times';

const { formData, formRef, disabled } = storeToRefs(infoStore());

const { uploadModelMap, onUploadErr, onUploadRemove, onUploadChange } =
  useUpload(formData, formRef, ['legalPersonCardZheng', 'legalPersonCardFan']);
</script>
